/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TodoStatus {
  Open = "open",
  Done = "done",
  Cancelled = "cancelled",
}

export function instanceOfTodoStatus(value: any): boolean {
  for (const key in TodoStatus) {
    if (Object.prototype.hasOwnProperty.call(TodoStatus, key)) {
      if (TodoStatus[key as keyof typeof TodoStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TodoStatusFromJSON(json: any): TodoStatus {
  return TodoStatusFromJSONTyped(json, false);
}

export function TodoStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TodoStatus {
  return json as TodoStatus;
}

export function TodoStatusToJSON(value?: TodoStatus | null): any {
  return value as any;
}

export function TodoStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TodoStatus {
  return value as TodoStatus;
}
